import React, { Component } from 'react'

//Loader import
import Loader from "../loader";
import _ from 'lodash'
import Select from 'react-select';
import TextField from '../../component/TextField'
import TextEditor from '../TextEditor';

import VideoImageFile from '../../component/VideoImageFile'
import ImageOnlyUpload from '../../pages/ImageOnlyUpload';
import VideoOnlyUpload from "../../pages/VideoOnlyUpload";

import background from "../../assets/images/background.jpg";

import plusIcon from "../../assets/images/plusIcon.svg";

// Slick Slider
import Slider from "react-slick";

//  Dat Picker
import DatePicker from "react-datepicker";

//moment import
import moment from "moment";

//Service import
import service from "../../services";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

// Images import
import calendar from "../../assets/images/calendar.svg";
import addIcon from "../../assets/images/add.svg";
import minusIcon from "../../assets/images/minus.svg";
import addIconBorder from "../../assets/images/add-border.svg";
import dashIcon from "../../assets/images/dash.svg";
import { withRouter } from 'react-router-dom';
import PopUpCustomAll from '../fpg/create/popUpCustomAll';
import ErrorPopUp from '../errorPopUp';
import ModalMessage from '../ModalMessage';
import commonImage from '../../commonImage';
import DropdownMaster from '../DropdownMaster';
import $ from 'jquery'
import FpgMinusIcon from '../../icons/fpgminusicon';

let sub
class PanelDisplayTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typing: false,
      typingTimeout: 0,
      errorPopup: false,
      messageModal: false,
      deleteId: '',
      isImage: false,
      startDate: new Date(),
      eventTitle: "",
      eventDisplayTemplate: "Panel",
      eventDescription: EditorState.createEmpty(),
      eventDetail: EditorState.createEmpty(),
      CTA: [],
      image1: null,
      featurePopup: false,
      titlePopup: false,
      availableThroughoutFestival: false,
      titleEventTop: false,
      selectPartnerFlag: false,
      imagePreloader: false,
      interest: '',
      featuredEventSearch: [],
      featuredEvent: [],
      detailImageOrVideo: [{
        _id: Math.random(),
        link: '',
        url: ''
      },
      {
        _id: Math.random(),
        link: '',
        url: ''
      },
      {
        _id: Math.random(),
        link: '',
        url: ''
      }],

      //Panel Template Variable Declaration Start
      eventDates: [
        {
          id: Math.random(),
          date: new Date(),
          eventParticularTime: [
            {
              date: new Date(),
              id: Math.random(),
              start: {
                hours: { value: '7', label: '7' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              },
              end: {
                hours: { value: '8', label: '8' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              },
              availability: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
              ],
              locationFlag: false,
              EventLocation: {
                // availability:{_id:'1',name: 'In-Person' },	
                locationName: "",
                street: "",
                city: "",
                state: "",
                zip: "",                

              },
            }
          ],
          time: [
            {
              date: new Date(),
              id: Math.random(),
              start: {
                hours: { value: '', label: '' },
                mins: { value: '', label: '' },
                stamps: { value: '', label: '' }
              },
              end: {
                hours: { value: '', label: '' },
                mins: { value: '', label: '' },
                stamps: { value: '', label: '' }
              },
              activityDetails: ''
            }
          ],

        }
      ],

      panalListArray: [
        {
          _id: Math.random(),
          image: '',
          name: '',
          bio: ''
        }

      ],
      // Panel Template Variable Declaration End

      partnerTitleEvent: false,
      description1: "",
      partnerId: "",
      loaderFlag: false,
      partnerNameList: [],
      addedBy: '',
      deleteFeatureID: '',
      deleteTitleID: '',
      offerOutboundUrl: '',
      availability: [
        { _id: '1', name: 'In-Person' },
        { _id: '2', name: 'Online' },
      ],
      keyEventThumbnailImage: [{
        _id: Math.random(),
        link: "",
        url: ""
      }

      ]
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount = () => {
    this.getAllEvent();
    if (this.props.panalUserID) {
      this.getPerticularEvent();
    }
    document.body.addEventListener('click', this.bodyClick);
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  }

  // Body Click
  bodyClick = (e) => {
    if (document.querySelector('.popup_wrapper')) {
      if (!e.target.closest('.popup_wrapper')) {
        this.setState({
          featurePopup: false,
          titlePopup: false
        })
      }
    }
  }

  /* Panel Session  Start*/
  addTimer = (parentId) => {
    this.setState({})
    var time =
    {
      date: new Date(),
      id: Math.random(),
      start: {
        hours: { value: '', label: '' },
        mins: { value: '', label: '' },
        stamps: { value: '', label: '' }
      },
      end: {
        hours: { value: '', label: '' },
        mins: { value: '', label: '' },
        stamps: { value: '', label: '' }
      },
      activityDetails: ''
    }

    this.state.eventDates.forEach(event => {
      if (event.id === parentId) {
        event.time.push(time)
      }
    });

  };

  removeTime = (parentId, childId) => {
    this.setState({})
    this.state.eventDates.forEach(event => {
      if (event.id === parentId) {
        event.time = event.time.filter(_ => _.id !== childId)
      }
    });

  };

  onChangeTime = (time, parentId, childId, timeZone, key) => {
    this.setState({})
    this.state.eventDates.forEach(event => {

      if (event.id === parentId) {
        event.time.forEach(eventTime => {
          if (eventTime.id === childId) {
            if (timeZone === 'Start') {
              if (key === 'Hours')
                eventTime.start.hours = time
              else if (key === 'Mins')
                eventTime.start.mins = time
              else
                eventTime.start.stamps = time
            }
            else if (timeZone === 'End') {
              if (key === 'Hours')
                eventTime.end.hours = time
              else if (key === 'Mins')
                eventTime.end.mins = time
              else
                eventTime.end.stamps = time
            } else {
              eventTime.activityDetails = time.target.value
            }
          };
        })
      }
    });
  };

  handleChange = (date, id) => {
    this.setState({})
    this.state.eventDates.forEach(event => {
      if (event.id === id) {
        event.date = date
      }
    });

  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeTimeEventTimeGeneral = (time, parentId, childId, timeZone, key) => {
    this.setState({})
    this.state.eventDates.forEach(event => {

      if (event.id === parentId) {
        event.eventParticularTime.forEach(eventTime => {
          if (eventTime.id === childId) {
            if (timeZone === 'Start') {
              if (key === 'Hours')
                eventTime.start.hours = time
              else if (key === 'Mins')
                eventTime.start.mins = time
              else
                eventTime.start.stamps = time
            }
            else {
              if (key === 'Hours')
                eventTime.end.hours = time
              else if (key === 'Mins')
                eventTime.end.mins = time
              else
                eventTime.end.stamps = time
            }
          }
        });
      }
    });
  };

  onChangeFilePanel(e, id) {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {

      this.setState({})

      setTimeout(() => {
        this.imageUploadPanel(file, id,event.target.result);
      }, 0);
    };
  }

  imageUploadPanel = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`
    const newState = { ...this.state }
    newState[imagePreloaderId] = true
    this.setState(newState)

    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
      this.state.panalListArray.forEach(eventPanel => {
        this.setState({ imagePreloader: false })

        if (eventPanel._id === id) {
          const imagePreloaderId = `imagePreloader_${id}`
          const newState = { ...this.state }
          newState[imagePreloaderId] = false
          this.setState(newState)
          eventPanel.image = value
        }
      });

      this.setState({})
    });
  };

  addPanel = () => {
    var newPanel = {
      _id: Math.random(),
      image: '',
      name: '',
      bio: ''
    }
    var oldPanel = this.state.panalListArray
    oldPanel.push(newPanel)
    this.setState({
      panalListArray: oldPanel
    });
  }

  removePanel = (i) => {
    var filteredDates = this.state.panalListArray.filter(_ => _._id !== i)

    this.setState({
      panalListArray: filteredDates
    });
  };


  addInterest = () => {
    var newInterest = {
      _id: Math.random(),
      interest: ''
    }
    var oldInterest = this.state.interest
    oldInterest.push(newInterest)
    this.setState({
      interest: oldInterest
    })
  }
  removeInterest = (i) => {
    var filterData = this.state.interest.filter(_ => _._id !== i)
    this.setState({
      interest: filterData
    })
  }

  onHandleChangePanel = (e, id) => {
    this.setState({})
    const { name, value } = e.target;
    this.state.panalListArray.forEach(eventPanel => {
      if (eventPanel._id === id)
        eventPanel[name] = value
    });
  }
  /* Panel Session  End*/

  onDisplayTypeChange = (event) => {
    this.setState({
      displayType: event.target.value,
    });
  };

  getAllEvent = () => {
    const { getLoginRole } = this.props
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "FestivalVillage|Event|createEvent":
          if (!response.error) {
            this.apiserve.success('Event Created successfully.')
            this.props.history.push("/partner-adminview");
          } else {
            this.setState({
              loaderFlag: false,
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "FestivalVillage|Event|getEventById":
          if (response.data.eventDescription) {
            const blocksFromHtml = htmlToDraft(response.data.eventDescription);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({
              editorState: editorState,
            })
          }
          if (response.data.eventDetail) {
            const blocksFromHtml = htmlToDraft(response.data.eventDetail);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorStateShort = EditorState.createWithContent(contentState);
            this.setState({
              editorStateShort: editorStateShort,
            })
          }

          var temp = []
          var time = []
          var dateTimeDate = []
          var timeContain = {}
          this.setState({
            locationFlag: response.data?.eventDate[0].eventParticularTime[0].availability === '1'
          })
          response.data && response.data.eventDate.map(item => {
            let hoursStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('h');
            let minutesStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('mm')
            let stateStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('A')
            let yearstart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('YYYY')
            let monthstart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('MM') - 1
            let datestart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('DD')
            let hoursend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('h');
            let minutesend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('mm')
            let stateend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('A')
            let yearend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('YYYY')
            let monthend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('MM') - 1
            let dateend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('DD')
            let availabilityValue = item.eventParticularTime[0].availability
            let EventLocationValue = item.eventParticularTime[0].EventLocation
            var dateTime = {
              date: new Date(yearstart, monthstart, datestart),
              eventParticularTime: [{
                start: {
                  date: new Date(yearstart, monthstart, datestart),
                  hours: { value: hoursStart, label: hoursStart },
                  mins: { value: minutesStart, label: minutesStart },
                  stamps: { value: stateStart, label: stateStart }
                },
                end: {
                  date: new Date(yearend, monthend, dateend),
                  hours: { value: hoursend, label: hoursend },
                  mins: { value: minutesend, label: minutesend },
                  stamps: { value: stateend, label: stateend }
                },
                availability: { _id: availabilityValue },
                EventLocation: {
                  // availability:{_id:'1',name: 'In-Person' },	
                  locationName: EventLocationValue?.locationName,
                  street: EventLocationValue?.street,
                  city: EventLocationValue?.city,
                  state: EventLocationValue?.state,
                  zip: EventLocationValue?.zip,
                },
              }],

            }
            item.time.map((timeList) => {
              let hoursTimeStart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('h') :''
              let minutesTimeStart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('mm') :''
              let stateTimeStart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('A') :''
              let yearTimestart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('YYYY') :''
              let monthTimestart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('MM') - 1 :''
              let dateTimestart = timeList.start?  moment(timeList.start).tz("US/Mountain").format('DD') :''

              let hoursTimeend = timeList.end?  moment(timeList.end).tz("US/Mountain").format('h') :''
              let minutesTimeend = timeList.end?  moment(timeList.end).tz("US/Mountain").format('mm') :''
              let stateTimeend = timeList.end?  moment(timeList.end).tz("US/Mountain").format('A') :''

              timeContain = {
                date: new Date(yearTimestart, monthTimestart, dateTimestart),
                id: Math.random(),
                start: {
                  hours: { value: hoursTimeStart, label: hoursTimeStart },
                  mins: { value: minutesTimeStart, label: minutesTimeStart },
                  stamps: { value: stateTimeStart, label: stateTimeStart }
                },
                end: {
                  hours: { value: hoursTimeend, label: hoursTimeend },
                  mins: { value: minutesTimeend, label: minutesTimeend },
                  stamps: { value: stateTimeend, label: stateTimeend }
                },
                activityDetails: timeList.activityDetails
              }

              time.push(timeContain)
              dateTimeDate = { ...dateTime, time }
            })
            temp.push(dateTimeDate)
          })

          this.setState({
            eventDisplayTemplate: response.data.eventDisplayTemplate,
            eventId: response.data._id,
            eventTitle: response.data.eventTitle,
            displayType: response.data.displayType,
            // eventDates: response.data.availableThroughoutFestival ? this.state.eventDates : temp,
            eventDates: temp,
            // availableThroughoutFestival: response.data.availableThroughoutFestival,
            availableThroughoutFestival: response.data?.eventDate[0].eventParticularTime[0].availability === '1' ? false : response.data.availableThroughoutFestival,
            titleEventTop: response.data.partnerTitleEvent,
            panalListArray: response.data.panelists,
            cta_title1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[0] &&
                response.data.CTA[0].title : '',
            cta_url1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[0] &&
                response.data.CTA[0].url : '',
            cta_title2:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].title : '',
            cta_url2:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].url : '',
            cta_description1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].description : '',
            keyEventThumbnailImage: response.data.keyEventThumbnailImage,
            detailImageOrVideo: response.data.detailImageOrVideo,
            featuredEvent: response.data.interest,
          });
          this.setState({ loaderFlag: false })
          break;
        case "FestivalVillage|Event|updateEvent":
          if (!response.error) {
            this.apiserve.success('Event Created successfully.')
            this.props.history.push("/partner-adminview");
          } else {
            this.setState({
              loaderFlag: false,
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "searchPartnerName":
          this.setState({
            partnerNameList: response.data.docs,
            selectPartnerFlag: true
          });
          break;
        case "deleteEvent":
          if (this.state.eventId) {
            this.updateEventData();
          } else {
            this.createEventData();
          }
          break;
        case "FestivalVillage|Event|Preview|create":
          if (!response.error) {
            this.setState({
              loaderFlag: false,
            }, () => {
              window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FESTIVAL_VILLAGE + 'film-preview');
            })
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;

        case "FestivalVillage|Event|searchInterest":
          if (!response.error) {
            if (this.state.interest && this.state.interest.length) {
              const featuredEventSearchData = this.state.featuredEventSearch && this.state.featuredEventSearch.map(item => item?._id);
              const featuredEventData = this.state.featuredEvent && this.state.featuredEvent.map(item => item?._id);
              const featuredList = response.data.docs.filter(
                item => !(featuredEventSearchData && featuredEventSearchData.includes(item._id) || featuredEventData && featuredEventData.includes(item._id))
              );
    
              this.setState({
                featuredEventSearch: featuredList,
              })
            }
          }
          break;
      }
    });
  };

  getPerticularEvent = () => {
    const { panalUserID } = this.props;
    this.apiserve.sendevent("FestivalVillage|Event|getEventById", {
      id: panalUserID,
    });
    this.setState({ loaderFlag: true })
  };

  getMtTime = (date) => {
    //Get offset from mountain time using UTC
    let offDifference = moment().utcOffset() + 360 ;

    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }

  eventDataCreateUpdate = () => {
    const { self } = this
    const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
    const markup = draftToHtml(name);

    const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
    const markupShort = draftToHtml(nameShort);
    this.state.keyEventThumbnailImage.forEach(element => {
      delete element._id
    });

    this.state.detailImageOrVideo.forEach(element => {
      delete element._id
    });

    this.state.panalListArray.forEach(element => {
      delete element._id
    });

    var eventDate = this.state && this.state.eventDates.map(item => {
      var eventDateList = new Date(item && item.date);
      eventDateList.setHours(item.eventParticularTime[0].start.stamps.value === 'PM' || item.eventParticularTime[0].start.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) : parseInt(item.eventParticularTime[0].start.hours.value) + 12 : parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) - 12 : parseInt(item.eventParticularTime[0].start.hours.value), item.eventParticularTime[0].start.mins.value);
      var eventDateListStart = this.getMtTime(eventDateList)
      eventDateList.setHours(item.eventParticularTime[0].end.stamps.value === 'PM' || item.eventParticularTime[0].end.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) : parseInt(item.eventParticularTime[0].end.hours.value) + 12 : parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) - 12 : parseInt(item.eventParticularTime[0].end.hours.value), item.eventParticularTime[0].end.mins.value);
      var eventDateListEnd = this.getMtTime(eventDateList)
      var time = []
      item.time.map((timeList) => {
        var timeListStart = new Date(timeList && timeList.date);
        timeListStart.setHours(timeList.start.stamps.value === 'PM' || timeList.start.stamps.value === 'pm' ? parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) : parseInt(timeList.start.hours.value) + 12 : parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) - 12 : parseInt(timeList.start.hours.value), timeList.start.mins.value)
        var timeDataStart = this.getMtTime(timeListStart)
        var timeListEnd = new Date(timeList && timeList.date);
        timeListEnd.setHours(timeList.end.stamps.value === 'PM' || timeList.end.stamps.value === 'pm' ? parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) : parseInt(timeList.end.hours.value) + 12 : parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) - 12 : parseInt(timeList.end.hours.value), timeList.end.mins.value)
        var timeDataEnd = this.getMtTime(timeListEnd)
        var temTime = {
          date: this.getMtTime(timeListStart),
          start: timeDataStart,
          end: timeDataEnd,
          activityDetails: timeList.activityDetails
        }
        time.push(temTime);
      })
      var eventParticularTime = [{
        date: this.getMtTime(eventDateList),
        start: eventDateListStart,
        end: eventDateListEnd,
        // availability:this.state.availability,	
        availability: this.state.locationFlag === true ? '1' : '2',
        EventLocation: {
          // availability:{_id:'1',name: 'In-Person' },	
          locationName: this.state.eventDates[0]?.eventParticularTime[0]?.EventLocation?.locationName,
          street: this.state.eventDates[0]?.eventParticularTime[0]?.EventLocation?.street,
          city: this.state.eventDates[0]?.eventParticularTime[0]?.EventLocation?.city,
          state: this.state.eventDates[0]?.eventParticularTime[0]?.EventLocation?.state,
          zip: this.state.eventDates[0]?.eventParticularTime[0]?.EventLocation?.zip,
        },
      }]
      var dateTime = {
        date: this.getMtTime(eventDateList),
        eventParticularTime: eventParticularTime,
        time: time
      }
      return dateTime
    })

    var result = _.filter(_.uniq(this.state.detailImageOrVideo, function (item, key, a) {
      return item._id;
    }), function (element) {
      return element.link || element.url
    });

    let featureList = this.state.featuredEvent.map(element => {
      // var data = {	
      //   interestId: element.interestId._id	
      // }	
      return element.interestId && element.interestId?._id ? element.interestId?._id : element && element._id
    });

    let data = {
      interest: featureList,
      eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
      eventTitle: this.state.eventTitle,
      eventDescription: markup,
      displayType: this.state.displayType,
      eventDetail: markupShort,
      partnerTitleEvent: this.state.titleEventTop,
      panelists: this.state.panalListArray,
      eventDate: eventDate,
      eventTypeTitle: "partner",
      availableThroughoutFestival: this.state.availableThroughoutFestival,
      // availability:this.state.availability[0]._id,	
      // EventLocation:{	
      //   // availability:{_id:'1',name: 'In-Person' },	
      //   locationName: this.state.locationName,	
      //   street: this.state.street,	
      //   city: this.state.city,	
      // } ,
      CTA:[
        {
          title: this.state.cta_title1,
          url: this.state.cta_url1,
        },
        {
          description: this.state.cta_description1,
          title: this.state.cta_title2,
          url: this.state.cta_url2,
        },
      ],
      keyEventThumbnailImage: this.state.keyEventThumbnailImage,
      detailImageOrVideo: this.state.detailImageOrVideo,
      frontDetailImageOrVideo: result
    };

    if (this.state.eventId) data.id = this.state.eventId
    this.apiserve.sendevent(this.state.eventId ? "FestivalVillage|Event|updateEvent" : "FestivalVillage|Event|createEvent", data);
  }

  previewRecord = (e) => {
    e.preventDefault()
    let previewDetails = {}
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
      const markup = draftToHtml(name);

      const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
      const markupShort = draftToHtml(nameShort);

      var eventDate = this.state && this.state.eventDates.map(item => {
        var eventDateList = new Date(item && item.date);
        eventDateList.setHours(item.eventParticularTime[0].start.stamps.value === 'PM' || item.eventParticularTime[0].start.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) : parseInt(item.eventParticularTime[0].start.hours.value) + 12 : parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) - 12 : parseInt(item.eventParticularTime[0].start.hours.value), item.eventParticularTime[0].start.mins.value);
        var eventDateListStart = this.getMtTime(eventDateList)
        eventDateList.setHours(item.eventParticularTime[0].end.stamps.value === 'PM' || item.eventParticularTime[0].end.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) : parseInt(item.eventParticularTime[0].end.hours.value) + 12 : parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) - 12 : parseInt(item.eventParticularTime[0].end.hours.value), item.eventParticularTime[0].end.mins.value);
        var eventDateListEnd = this.getMtTime(eventDateList)
        var time = []
        item.time.map((timeList) => {
          var timeListStart = new Date(timeList && timeList.date);
          timeListStart.setHours(timeList.start.stamps.value === 'PM' || timeList.start.stamps.value === 'pm' ? parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) : parseInt(timeList.start.hours.value) + 12 : parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) - 12 : parseInt(timeList.start.hours.value), timeList.start.mins.value)
          var timeDataStart = this.getMtTime(timeListStart)
          var timeListEnd = new Date(timeList && timeList.date);
          timeListEnd.setHours(timeList.end.stamps.value === 'PM' || timeList.end.stamps.value === 'pm' ? parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) : parseInt(timeList.end.hours.value) + 12 : parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) - 12 : parseInt(timeList.end.hours.value), timeList.end.mins.value)
          var timeDataEnd = this.getMtTime(timeListEnd)
          var temTime = {
            date: this.getMtTime(timeListStart),
            start: timeDataStart,
            end: timeDataEnd,
            activityDetails: timeList.activityDetails
          }
          time.push(temTime);
        })
        var eventParticularTime = [{
          date: this.getMtTime(eventDateList),
          start: eventDateListStart,
          end: eventDateListEnd
        }]
        var dateTime = {
          date: this.getMtTime(eventDateList),
          eventParticularTime: eventParticularTime,
          time: time
        }
        return dateTime
      })

      var result = _.filter(_.uniq(this.state.detailImageOrVideo, function (item, key, a) {
        return item._id;
      }), function (element) {
        return element.link || element.url
      });


      previewDetails = {
        eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
        eventTitle: this.state.eventTitle,
        eventDescription: markup,
        displayType: this.state.displayType,
        eventDetail: markupShort,
        partnerTitleEvent: this.state.titleEventTop,
        panelists: this.state.panalListArray,
        eventDate: eventDate,
        eventTypeTitle: "partner",
        availableThroughoutFestival: this.state.availableThroughoutFestival,
        CTA: [
          {
            title: this.state.cta_title1,
            url: this.state.cta_url1,
          },
          {
            description: this.state.cta_description1,
            title: this.state.cta_title2,
            url: this.state.cta_url2,
          },
        ],
        keyEventThumbnailImage: this.state.keyEventThumbnailImage,
        detailImageOrVideo: this.state.detailImageOrVideo,
        frontDetailImageOrVideo: result
      };
      if (this.state.eventId) previewDetails.id = this.state.eventId
      let previewString = this.apiserve.encrypt(previewDetails)
      this.apiserve.sendevent("FestivalVillage|Event|Preview|create", { previewString });
    } else {
      this.setState({
        messageModal: true,
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  submitFn = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      this.eventDataCreateUpdate();
    } else {
      this.setState({
        messageModal: true,
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  ClosemessageModal = () => {
    this.setState({
      messageModal: false,
    })
  }


  //Partner Title Event Start
  partnerTitleEventCheck = (e) => {
    const { getLoginRole } = this.props;
    this.setState({
      titleEventTop: e.target.checked
    })
  }

  //Partner Title Event Start
  availableThroughoutFestival = (e) => {
    const { getLoginRole } = this.props;
    this.setState({
      availableThroughoutFestival: e.target.checked
    })
  }

  cancelFn = () => {
    this.props.history.push('/partner-adminview')
  };

  onEditorStateDescription = (editorState) => {
    this.setState({ editorState });
  };

  onEditorStateDetail = (editorStateShort) => {
    this.setState({ editorStateShort });
  };

  handleImage(e, id) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
          setTimeout(() => {
            this.imageUploadOne(file, id,event.target.result);
          }, 0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      })
    }
  }

  imageUploadOne = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`
    const newState = { ...this.state }
    newState[imagePreloaderId] = true
    this.setState(newState)
    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
        this.state.keyEventThumbnailImage.forEach(image => {

          const imagePreloaderId = `imagePreloader_${id}`
          const newState = { ...this.state }
          newState[imagePreloaderId] = false
          this.setState(newState)
          if (image._id === id) {

            image.link = value
          }

        });
        this.setState({})
      });
  };

  OnchangeImage = (e, id) => {
    const { name, value } = e.target
    this.state.keyEventThumbnailImage.forEach(image => {
      if (image._id === id) {
        image.url = value
      }

    });
    this.setState({})

  }

  onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          // this.setState({ isImage: true })

          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB'
          })
        }
      } else {
        if (file.size > 200e6) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a video smaller than 200 MB"
          });
          return false;
        }

        if (file.type === "video/mp4") {

          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0);
          return false;
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      }
    };
  };

  uploadVideoImage = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state, videoPreLoader: true };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
      this.state.detailImageOrVideo.forEach(image => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state };
        newState[imagePreloaderId] = false;
        this.setState(newState);

        if (image._id === id) {

          image.link = value;
        }
      });
      this.setState({});
    });
  };

  insideFilechange = (e, id) => {
    const { name, value } = e.target
    this.state.detailImageOrVideo.forEach(image => {
      if (image._id === id) {
        image.url = value;
      }
    });
    this.setState({})
  }

  setDeleteImagePopup = (e, id) => {
    this.setState({
      deleteImagePopup: true,
      deleteId: id
    })
  }

  onDeleteImagePopup = () => {
    this.state.keyEventThumbnailImage.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.link = "";
      }
    });

    this.state.detailImageOrVideo.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.link = "";
      }
    });

    this.setState({
      deleteImagePopup: false
    })
  }

  closeAdminUser = () => {
    this.setState({ deleteImagePopup: false })
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  onChangeLocation = (e) => {
    const { name, value } = e.target;
    let Location = this.state.eventDates;
    Location[0].eventParticularTime[0].EventLocation[name] = value
    this.setState({ eventDates: Location })
    // this.validator.hideMessage();	
  }
  onSearchFilter = (e) => {
    const { name, value } = e.target;
    var self = this;
    // this.state.interestArray.forEach(eventPanel => {	
    //   if (eventPanel._id === id)	
    //     eventPanel[name] = value	
    // });	


    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }
    this.setState({
      [name]: value,
      typing: false,
      typingTimeout: setTimeout(function () {
        if (value) self.apiserve.sendevent("FestivalVillage|Event|searchInterest", { filter: value });
      }, 500)
    });
  };

  searchAddFeatured = (item) => {

    let data = {
      _id: item._id,
      interestId: item
    }
    this.setState({
      featuredEvent: [...this.state.featuredEvent, data],
      interest: '',
      featuredEventSearch: [],
    });
  }
  removeFeatured = i => {
    var featuredEvent = this.state.featuredEvent.filter(_ => _._id !== i)
    this.setState({
      featuredEvent: featuredEvent
    });
  }
  onChangeScreeningType = (e, id) => {
    const { value } = e.target;
    var Fest = value === '1' ? false : this.state.availableThroughoutFestival
    this.setState({
      locationFlag: value === '1',
      availableThroughoutFestival: Fest
    })
    let DATES = this.state.eventDates
    DATES[0].eventParticularTime[0].availability._id = value

    DATES[0].eventParticularTime[0].EventLocation.locationName = ''
    DATES[0].eventParticularTime[0].EventLocation.street = ''
    DATES[0].eventParticularTime[0].EventLocation.city = ''
    DATES[0].eventParticularTime[0].EventLocation.state = ''
    DATES[0].eventParticularTime[0].EventLocation.zip = ''

    this.setState({
      eventDates: DATES,
    })
    this.validator.hideMessages();
  }

  getHtmlValue = (value) => {
    
    try {
      const convertedValue = value ? convertToRaw(value.getCurrentContent()) :''
      return convertedValue ? convertedValue.blocks[0].text : ''
    } catch (error) {
      console.log('error',error);
    }
    
  }

  render() {
    this.validator.purgeFields();
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const Hours = [
      { value: '12', label: '12' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
    ]

    const Mins = [
      { value: '00', label: '00' },
      { value: '15', label: '15' },
      { value: '20', label: '20' },
      { value: '25', label: '25' },
      { value: '30', label: '30' },
      { value: '35', label: '35' },
      { value: '40', label: '40' },
      { value: '45', label: '45' },
      { value: '50', label: '50' },
      { value: '55', label: '55' },
    ]

    const Stamps = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' }
    ]

    const { availableThroughoutFestival, eventDates, panalListArray, } = this.state;
    return (
      <section
        id="Panel"
        className="tab-panel screenigBlock_wrapper PanelBlock_wrapper"
      >
        <form>
          <div className="EventTitle_block">
            <div className="textarea_block form_group">
              <h5 className="left_label required">Event Title</h5>
              <div className="form_group_textarea">
                <input
                  type="text"
                  name="eventTitle"
                  id="eventTitle"
                  value={this.state.eventTitle}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error">
                  {this.validator.message(
                    "event title",
                    this.state.eventTitle,
                    "required"
                  )}
                </span>
              </div>
              <div className="eventDate_block">
                <h5 className="left_label"></h5>
                <div className="customCheck">
                  <div className="customCheckBox">
                    <input
                      type="checkbox"
                      id="titleEventTop"
                      value={this.state.titleEventTop}
                      checked={this.state.titleEventTop}
                      onClick={(e) => this.partnerTitleEventCheck(e, "titleEventTop")}
                    />
                    <label htmlFor="titleEventTop">
                      Partner Title Event
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="description_block sd_editer_event">
            <div className="textarea_block form_group">
              <h5 className="left_label required">Event Description </h5>
              <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                <TextEditor
                  name="editorState"
                  editorState={this.state.editorState}
                  value={this.state.editorState}
                  onEditorStateChange={(e) =>
                    this.onEditorStateDescription(e)} />
                <span className="error ml_0"> {this.validator.message("Event Description",  this.getHtmlValue(this.state.editorState), "required")} </span>

              </div>
            </div>
            <div className="textarea_block form_group">
              <h5 className="required">Event Detail</h5>
              <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                <TextEditor
                  name="editorStateShort"
                  editorState={this.state.editorStateShort}
                  value={this.state.editorStateShort}
                  onEditorStateChange={(e) =>
                    this.onEditorStateDetail(e)} />
                <span className="error ml_0"> {this.validator.message("Event Detail",  this.getHtmlValue(this.state.editorStateShort), "required")} </span>

              </div>
            </div>
          </div>
          <div className="eventDate_block">
            <h5 className="left_label"></h5>
            <div className="customCheck">
              <div className="customCheckBox">
                <input
                  type="checkbox"
                  id="availableThroughoutFestival"
                  value={this.state.availableThroughoutFestival}
                  checked={this.state.availableThroughoutFestival}
                  onClick={(e) => this.availableThroughoutFestival(e, "availableThroughoutFestival")}
                  disabled={this.state.eventDates[0].eventParticularTime[0].availability._id === '1' ? true : false}
                />
                <label htmlFor="availableThroughoutFestival">
                  Available Throughout Festival
                </label>
              </div>
            </div>
          </div>
          {availableThroughoutFestival ? '' :
          <div className="eventDate_block_Wrapper">
            <h5 className="left_label">Event Date</h5>
            <div className="eventData_block">
              {/* Panal Event Start */}
              {/* General Event Start */}
              <>
                {eventDates && eventDates.map((x, i) => {
                  return (
                    <>
                      <div className="event-data-block-main" key={i}>
                        <div className="event-title-block">
                          <input
                            type="text"
                            id={x.id}
                            value={moment(
                              x.date
                            ).format("MM/DD/YYYY")}
                            placeholder="mm / dd / yyyy"
                            autoComplete="off"
                          />
                          <DatePicker
                            selected={x.date}
                            onChange={(e) => this.handleChange(e, x.id)}
                            minDate={moment().toDate()}
                            placeholder="mm/dd/yyyy"
                            customInput={
                              <img
                                src={calendar}
                                className="calendar"
                              />
                            }
                          />
                        </div>
                        <div className="event-time-main-wpr">
                          <div className="event_main">
                            <div className="event-time-section">
                              <h5>Event Time (MT)</h5>

                              <div className="event-time-main">

                                {x.eventParticularTime ?
                                  x.eventParticularTime.map((xTime, i) => {
                                    return (
                                      <>
                                        <div
                                          className="onClickPlus"
                                          key={i}
                                        >
                                          <div className="event-time-block">
                                            <Select
                                              id={xTime.id}
                                              value={xTime.start.hours}
                                              options={Hours}
                                              placeholder="7"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Hours')
                                              } />
                                            <Select
                                              value={xTime.start.mins}
                                              options={Mins}
                                              placeholder="30"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Mins')
                                              } />
                                            <Select
                                              value={xTime.start.stamps}
                                              options={Stamps}
                                              placeholder="AM"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Stamps')
                                              } />

                                            <span>
                                              <img src={dashIcon} />
                                            </span>

                                            <Select
                                              value={xTime.end.hours}
                                              options={Hours}
                                              placeholder="7"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Hours')
                                              } />
                                            <Select
                                              value={xTime.end.mins}
                                              options={Mins}
                                              placeholder="30"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Mins')
                                              } />
                                            <Select
                                              value={xTime.end.stamps}
                                              options={Stamps}
                                              placeholder="AM"
                                              onChange={(e) =>
                                                this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Stamps')
                                              } />
                                          </div>
                                          {/* <div className="event-activity-block">
                                        <DropdownMaster
                                          name="availability"
                                           onChange= {(e) => this.onChangeScreeningType(e,xTime._id)}
                                          value={xTime && xTime.locationType && xTime.locationType._id}
                                          options={this.state.locationType}
                                        />

                                      </div> */}

                                          <div className=" event-activity-block">
                                            <DropdownMaster
                                              name="availability"
                                              onChange={(e) => this.onChangeScreeningType(e, xTime.availability._id)}
                                              value={xTime.availability && xTime.availability._id}
                                              options={this.state.availability}
                                            />

                                          </div>
                                        </div>
                                        {this.state.locationFlag && <div className="event-time-section event_location">

                                          <h5>Event Location</h5>
                                          <div className="event-time-main event-location">
                                            <div className="event_input">
                                              <input
                                                type="text"
                                                placeholder="Location Name"
                                                id={xTime._id}
                                                name='locationName'
                                                value={xTime.EventLocation?.locationName}
                                                onChange={(e) => this.onChangeLocation(e)}
                                                autoComplete="off"
                                              />
                                            </div>


                                            <div className="event_input">
                                              <input
                                                type="text"
                                                placeholder="Street Address"
                                                id={xTime._id}
                                                name='street'
                                                value={xTime.EventLocation?.street}
                                                onChange={(e) => this.onChangeLocation(e)}
                                                autoComplete="off"
                                              />
                                              <span className="error">
                                                {this.validator.message("street", xTime.EventLocation?.street, xTime.availability && xTime.availability._id === '1' ? "required" : '')}
                                              </span>
                                            </div>
                                            <div className="event_input">
                                              <input
                                                type="text"
                                                placeholder="City"
                                                id={xTime._id}
                                                name='city'
                                                value={xTime.EventLocation?.city}
                                                onChange={(e) => this.onChangeLocation(e)}
                                                autoComplete="off"
                                              />
                                              <span className="error">
                                                {this.validator.message("city", xTime.EventLocation?.city, xTime.availability && xTime.availability._id === '1' ? "required" : '')}
                                              </span>
                                            </div>
                                            <div className="event_input">
                                              <input
                                                type="text"
                                                placeholder="State"
                                                id={xTime._id}
                                                name='state'
                                                value={xTime.EventLocation?.state}
                                                onChange={(e) => this.onChangeLocation(e)}
                                                autoComplete="off"
                                              />
                                              <span className="error">
                                                {this.validator.message("state", xTime.EventLocation?.state, xTime.availability && xTime.availability._id === '1' ? "required" : '')}
                                              </span>
                                            </div>
                                            <div className="event_input">
                                              <input
                                                type="text"
                                                placeholder="Zip"
                                                id={xTime._id}
                                                name='zip'
                                                value={xTime.EventLocation?.zip}
                                                onChange={(e) => this.onChangeLocation(e)}
                                                autoComplete="off"
                                              />
                                              <span className="error">
                                                {this.validator.message("zip", xTime.EventLocation?.zip, xTime.availability && xTime.availability._id === '1' ? "required" : '')}
                                              </span>
                                            </div>

                                          </div>
                                        </div>}
                                      </>
                                    );
                                  })
                                  : ''
                                }

                              </div>
                            </div>
                            {/* { this.state.locationFlag === true && <div className="event-time-section event_location">*/}
                          </div>
                          <div className="event-time-section">

                            <h5>Activity Time (MT)</h5>
                            <div className="event-time-main">
                              {x && (x.time.map((xTime, i) => {
                                return (
                                  <div
                                    className="onClickPlus"
                                    key={i}
                                  >
                                    <div className="event-time-block">
                                      <Select
                                        id={xTime.id}
                                        value={xTime.start.hours ? xTime.start.hours :'' }
                                        options={Hours}
                                        placeholder="00"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'Start', 'Hours')
                                        } />
                                      <Select
                                        value={xTime.start.mins ? xTime.start.mins : ''}
                                        options={Mins}
                                        placeholder="00"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'Start', 'Mins')
                                        } />
                                      <Select
                                        value={xTime.start.stamps ? xTime.start.stamps : ''}
                                        options={Stamps}
                                        placeholder="AM"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'Start', 'Stamps')
                                        } />

                                      <span>
                                        <img src={dashIcon} />
                                      </span>

                                      <Select
                                        value={xTime.end.hours ? xTime.end.hours : ''}
                                        options={Hours}
                                        placeholder="7"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'End', 'Hours')
                                        } />
                                      <Select
                                        value={xTime.end.mins ? xTime.end.mins : ''}
                                        options={Mins}
                                        placeholder="30"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'End', 'Mins')
                                        } />
                                      <Select
                                        value={xTime.end.stamps ? xTime.end.stamps : ''}
                                        options={Stamps}
                                        placeholder="AM"
                                        onChange={(e) =>
                                          this.onChangeTime(e, x.id, xTime.id, 'End', 'Stamps')
                                        } />

                                    </div>
                                    <div className="event-activity-block">
                                      <input
                                        type="text"
                                        placeholder="Activity Details"
                                        name={xTime.activityDetails}
                                        id={xTime.id}
                                        value={xTime.activityDetails ? xTime.activityDetails :''}
                                        onChange={(e) => this.onChangeTime(e, x.id, xTime.id, 'Activity')}
                                        autoComplete="off"
                                      />
                                    </div>
                                    {i === 0 ? (
                                      <>
                                        <a
                                          onClick={() =>
                                            this.addTimer(x.id)
                                          }
                                        >
                                          <img src={addIcon} />
                                        </a>
                                        <img
                                          src={addIconBorder}
                                          className="border"
                                        />
                                      </>
                                    ) : (
                                      <a
                                        onClick={() => this.removeTime(x.id, xTime.id)}
                                      >
                                        <img src={minusIcon} />
                                      </a>
                                    )}
                                  </div>
                                );
                              })
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </>
              {/* //General Event End */}
              {/* Panal Event End */}
            </div>
          </div>
          }
          <div className="penlistBlock">
            <div>
              <div className="cta_block_wrapper">
                <div className="cta_title form_group">
                  <h5 className="left_label required">Join Button Title</h5>
                  <div className="form_group_input form_group_input_span">
                    <input
                      type="text"
                      name="cta_title1"
                      id="cta_title1"
                      value={this.state.cta_title1}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error"> {this.validator.message("Join Button Title", this.state.cta_title1, "required")} </span>
                  </div>
                </div>
                <div className="cta_url form_group">
                  <h5 className="left_label required">Join Button URL</h5>
                  <div className="form_group_input form_group_input_span">
                    <input
                      type="text"
                      name="cta_url1"
                      id="cta_url1"
                      value={this.state.cta_url1}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    <span className="error"> {this.validator.message("Join Button url", this.state.cta_url1, "required|url")} </span>
                  </div>
                </div>
                {/* <div className="textarea_block from_group">
                  <h5 className="left_label required">
                    Above CTA 2 Description
                  </h5>
                  <div className="from_group_input">
                    <textarea
                      name="cta_description1"
                      id="cta_description1"
                      value={this.state.cta_description1}
                      onChange={this.onInputChange}
                    ></textarea>
                    <span className="error"> {this.validator.message("cta 2 Description", this.state.cta_description1, "required")} </span>

                  </div>
                </div> */}
                <div className="cta_title from_group">
                  <h5 className="left_label">CTA 2 Title</h5>
                  <div className="from_group_input">
                    <input
                      type="text"
                      name="cta_title2"
                      id="cta_title2"
                      value={this.state.cta_title2}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    {/* <span className="error"> {this.validator.message("cta 2 Title", this.state.cta_title2, "required")} </span> */}

                  </div>
                </div>
                <div className="cta_url from_group">
                  <h5 className="left_label">CTA 2 URL</h5>
                  <div className="from_group_input">
                    <input
                      type="text"
                      name="cta_url2"
                      id="cta_url2"
                      value={this.state.cta_url2}
                      onChange={this.onInputChange}
                      autoComplete="off"
                    />
                    {/* <span className="error"> {this.validator.message("cta 2 url", this.state.cta_url2, "required|url")} </span> */}

                  </div>
                </div>
              </div>
              <div className="EventTitle_block">
                <div className="textarea_block form_group mr_25">
                  <h5 className="left_label">Detail Images or Videos</h5>
                </div>
                <div className="video_slider uploads_files mb_25" style={{ display: "block" }}>
                  <Slider {...settings}>
                    {this.state.detailImageOrVideo.length && this.state.detailImageOrVideo.map((item, i) => {
                      const imagePreloaderState = `imagePreloader_${item._id}`;
                      return (
                        this.state.isImage ||
                          item.link.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null || item.url.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                          ?
                          <div className="uploads_files file_upload_400 relative">
                            <VideoImageFile
                              item={item._id}
                              handleImage={(e) => this.onChangeFile(e, item._id)}
                              iconDelete={true}
                              size="2"
                              id={item._id}
                              image={item.url}
                              showDeleteIcon={item.link}
                              value={item.link ? this.apiserve.imageUrl + item.link : item.url}
                              insideOnchange={(e) => this.insideFilechange(e, item._id)}
                              videoPreLoader={this.state[imagePreloaderState]}
                              deleteImage={(e) => this.setDeleteImagePopup(e, item._id)}
                              isboth={true}
                              textChange={true} />
                          </div>
                          :
                          <div className="uploads_files file_upload_400 relative">
                            <VideoOnlyUpload
                              handleVideo={(e) => this.onChangeFile(e, item._id)}
                              url={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                              video={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                              videoUrl={item.url}
                              insideOnchange={(e) => this.insideFilechange(e, item._id)}
                              item={item}
                              iconDelete={true}
                              showDeleteIcon={item.link}
                              videoPreLoader={this.state[imagePreloaderState]}
                              deleteVideo={(e) => this.setDeleteImagePopup(e, item._id)}
                              uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
                            />
                          </div>

                      );
                    })}
                  </Slider>
                </div>
              </div>
              <div className="EventTitle_block">
                <div className="textarea_block form_group mr_25">
                  <h5 className="left_label">Key Event Thumbnail Image</h5>
                </div>
                {this.state.keyEventThumbnailImage &&
                  this.state.keyEventThumbnailImage.map((item, index) => {
                    const imagePreloaderState = `imagePreloader_${item._id}`
                    return (
                      <div className="file_upload_400">
                        <div className="uploads_files">
                          <ImageOnlyUpload
                            item={item._id}
                            handleImage={(e) => this.handleImage(e, item._id)}
                            deleteImage={(e) => this.setDeleteImagePopup(e, item._id)}
                            iconDelete={true}
                            showDeleteIcon={item.link}
                            size="2"
                            id={item._id}
                            image={item.url}
                            value={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                            ImagePreLoader={this.state[imagePreloaderState]}
                            insideOnchange={(e) => this.OnchangeImage(e, item._id)}
                            isboth={false}
                          />
                        </div>
                      </div>
                    )
                  })}
              </div>
              
              <div className="interest from_group textfield_add_remove d_flex d_flex_align_center">	
                    <>	
                      	
                      	
                          <>	
                            {/* <h5 className="left_label ">Interest</h5> */}	
                            <div className=" field_row" id="open1">	
                              <TextField	
                               label="Interest" 	
                                type="text"	
                                // id={this.state._id}	
                                name='interest'	
                                value={this.state.interest}	
                                onChange={(e) => this.onSearchFilter(e)}	
                                autoComplete="off"	
                              />	
                              	
                            </div>	
                            {/* <p className="action_wrap d_flex d_flex_align_center action_wrap ">	
                            {i === 0 ? <>	
                                <a onClick={() => this.addInterest(item._id)} className="action_btn add_btn"><img src={addIcon} /></a>	
                                <img src={addIconBorder} className="border" />	
                              </> :	
                                (	
                                  <a onClick={() => this.removeInterest(item._id)} className="action_btn remove_btn">	
                                    <img src={minusIcon} />	
                                  </a>	
                                )	
                              }	
                            </p> */}		
                            <ul className="suggession_coupon mx_100 cms_bg" id="popup1">	
                              {this.state.featuredEventSearch.map((search, i) => (	
                                <li onClick={() => this.searchAddFeatured(search)}>	
                                  {search.name ? search.name : ''}	
                                </li>	
                              ))}	
                            </ul>	
                            <ul className="featured_remove">	
                              {this.state.featuredEvent.map((remove, i) => (	
                                <li>	
                                  <div className="inner_remove d_flex">	
                                    <p>{remove &&  remove.interestId &&  remove.interestId.name ? remove && remove.interestId &&  remove.interestId.name : remove && remove.name}</p>	
                                    <span className="pointer" onClick={e => this.removeFeatured(remove._id)}><FpgMinusIcon width="20px" height="20px" color="#7758B3" /></span>	
                                  </div>	
                                </li>	
                              ))}	
                            </ul>	
                           	
                          </>	
                       	
                    </>	
                  </div>

            </div>
            <div className="PanelistsWrapper">
              <h5>Panelists</h5>
              <div>
                {panalListArray && panalListArray.map((panelList, i) => {
                  const imagePreloaderState = `imagePreloader_${panelList._id}`

                  return (
                    <div className="userBlock">
                      <div className='image_pre_loader'>
                        <input
                          id={panelList._id}
                          type="file"
                          ref={(ref) => (this.upload = ref)}
                          // style={{ display: "none" }}
                          onChange={(e) => this.onChangeFilePanel(
                            e, panelList._id
                          )}
                          accept=".png, .jpg, .jpeg"
                        />
                        {this.state[imagePreloaderState] ?
                          <Loader id={panelList._id} />
                          :
                          <img
                            src={
                              panelList.image
                                ? this.apiserve.imageUrl + panelList.image
                                : background
                            }
                          />
                        }
                        <a
                        // onClick={() => {
                        //   this.upload.click();
                        // }}
                        >
                          <img src={plusIcon} />
                        </a>
                      </div>
                      <div>
                        <div className="user_block_wpr mb_10">
                          <input
                            type="text"
                            placeholder="Name"
                            id={panelList._id}
                            name='name'
                            className="mb_0"
                            value={panelList.name}
                            onChange={(e) => this.onHandleChangePanel(e, panelList._id)}
                            autoComplete="off"
                          />
                          {/* <span className="error">
                            {this.validator.message(
                              "name",
                              panelList.name,
                              "required"
                            )}
                          </span> */}
                        </div>
                        <div className="imagesBlockPlus_wrapper user_block_wpr">
                          <div className="user_block_wpr_inner">
                            <textarea
                              type="text"
                              id={panelList._id}
                              placeholder="Bio"
                              name='bio'
                              value={panelList.bio}
                              onChange={(e) => this.onHandleChangePanel(e, panelList._id)}
                            ></textarea>
                            {i === 0 ? (
                              <>
                                <a onClick={() => this.addPanel(panelList._id)}>
                                  <img src={addIcon} />
                                </a>
                                <img
                                  src={addIconBorder}
                                  className="border"
                                />
                              </>
                            ) : (
                              <a onClick={() => this.removePanel(panelList._id)}>
                                <img src={minusIcon} />
                              </a>
                            )}
                          </div>
                          {/* <span className="error">
                            {this.validator.message(
                              "bio",
                              panelList.bio,
                              "required"
                            )}
                          </span> */}
                        </div>
                      </div>

                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className="text_center field_row w_100 buttons_outer mb_0">
            <button
              className="grayBTN"
              type="button"
              onClick={() => this.cancelFn()}
            >
              Cancel
            </button>
            {/* <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button> */}
            <button
              className="orangeBTN"
              type="button"
              disabled={this.state.imagePreloader ? true : false}
              onClick={this.submitFn}
            >
              Submit
            </button>
          </div>
        </form>
        {this.state.deleteImagePopup
          ? <PopUpCustomAll
            HeaderName="Delete Image?"
            insideDetails="Are You Sure ?"
            insideData="You want to delete this image"
            popupState={() => this.closeAdminUser()}
            yesPopUp={() => this.onDeleteImagePopup()} />
          : ""
        }
        {this.state.errorPopup ?
          <ErrorPopUp
            errorMsg={this.state.errorMsg}
            errorMsgPopup={this.errorMsgPopup}
          />
          : ''
        }
        {this.state.messageModal &&
          <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
        }
      </section>
    )
  }
}
export default withRouter(PanelDisplayTemplate)
